export default __webpack_public_path__ + "static/media/order-and-pay-ahead.da30f135.webp";